import { ROLES } from '@/constants/roles';
import useAppStore from '@/store/app.store';
import { CompanyDetailsTab, MoeveActionsTab, TabPanel, TabsGroup } from './components';
import useSettingsStore from './store/useSettingsStore';

import * as styles from './SettingsView.css';

export default function SettingsView() {
  const selectedTab = useSettingsStore((state) => state.selectedTab);
  const user = useAppStore((state) => state.user);

  return user ? (
    <div className={styles.settingsView}>
      {user.role === ROLES.MOEVE_ADMIN ? (
        <>
          <TabsGroup />
          <TabPanel value={selectedTab} index={0}>
            <MoeveActionsTab />
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <CompanyDetailsTab user={user} />
          </TabPanel>
        </>
      ) : (
        <CompanyDetailsTab user={user} />
      )}
    </div>
  ) : null;
}
